var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineAirline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 70,
    viewBox: "0 0 72 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.28125,
    y: 0.0463867,
    width: 70.8339,
    height: 69.8339,
    rx: 34.9169,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 44.1424C24.5906 44.1424 23.082 43.7588 21.7183 42.9917C20.3546 42.2076 19.2722 41.1252 18.471 39.7444C17.6869 38.3466 17.2948 36.7784 17.2948 35.0396C17.2948 33.3009 17.6869 31.7412 18.471 30.3604C19.2722 28.9626 20.3546 27.8802 21.7183 27.1131C23.082 26.329 24.5906 25.9369 26.2441 25.9369C27.9146 25.9369 29.4318 26.329 30.7955 27.1131C32.1592 27.8802 33.2331 28.9541 34.0172 30.3349C34.8013 31.7156 35.1934 33.2839 35.1934 35.0396C35.1934 36.7954 34.8013 38.3637 34.0172 39.7444C33.2331 41.1252 32.1592 42.2076 30.7955 42.9917C29.4318 43.7588 27.9146 44.1424 26.2441 44.1424ZM26.2441 42.1224C27.4885 42.1224 28.605 41.8326 29.5937 41.253C30.5994 40.6734 31.3836 39.8467 31.9461 38.7728C32.5257 37.6989 32.8154 36.4545 32.8154 35.0396C32.8154 33.6078 32.5257 32.3634 31.9461 31.3065C31.3836 30.2326 30.608 29.4058 29.6193 28.8263C28.6306 28.2467 27.5055 27.9569 26.2441 27.9569C24.9827 27.9569 23.8576 28.2467 22.8689 28.8263C21.8803 29.4058 21.0961 30.2326 20.5165 31.3065C19.954 32.3634 19.6728 33.6078 19.6728 35.0396C19.6728 36.4545 19.954 37.6989 20.5165 38.7728C21.0961 39.8467 21.8803 40.6734 22.8689 41.253C23.8747 41.8326 24.9997 42.1224 26.2441 42.1224ZM49.0554 40.7928H42.3562L41.2823 43.9634H36.7054L43.2 26.0136H48.2628L54.7574 43.9634H50.1293L49.0554 40.7928ZM47.9304 37.4176L45.7058 30.8463L43.5069 37.4176H47.9304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineAirline);
export default __webpack_public_path__ + "static/media/online-airline.9c2a1bd857a86cca664885aca468db37.svg";
export { ForwardRef as ReactComponent };